import React from "react";
import "./OAuthLoadingScreen.scss";

interface OAuthLoadingScreenProps {
  message?: string;
  submessage?: string;
}

/**
 * Loading screen component for OAuth flows
 * Styled to match acquire-portal's Bootstrap-based design
 */
export const OAuthLoadingScreen: React.FC<OAuthLoadingScreenProps> = ({
  message = "Completing Sign In...",
  submessage = "Please wait while we securely log you in.",
}) => {
  return (
    <div className="oauth-loading-screen d-flex flex-column align-items-center justify-content-center vh-100">
      <div className="loading-content text-center">
        <div className="spinner-container mb-4">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>

        <h2 className="h4 mb-3">{message}</h2>

        <p className="text-muted">{submessage}</p>
      </div>
    </div>
  );
};

export default OAuthLoadingScreen;
